import { BaseMethod } from "./_Base";
import { CoreUserAgent } from "../../../core/UserAgent";
export class isDeviceTouchExpression extends BaseMethod {
  constructor() {
    super(...arguments);
    this._requireDependency = true;
  }
  static requiredArguments() {
    return [];
  }
  async processArguments(args) {
    return new Promise(async (resolve, reject) => {
      resolve(CoreUserAgent.isTouchDevice());
    });
  }
}
